import { Router } from '@lightningjs/sdk'

import Button from '../../components/button/button'
import { BASE_ROUTES, SUBSCRIPTION } from '../../constants/routes'
import { getText } from '../../utils/dictionary'
import BaseLanding from './baseLanding'

export default class Paywall extends BaseLanding {
  static _template() {
    return {
      ...super._template(),
      ManageSubscriptionButton: {
        y: 860,
        x: 137,
        type: Button,
        label: getText('paywallManagerSubscription'),
      },
      Title: {
        ...super._template().Title,
        w: 1026,
        y: 676,
      },
      Subtitle: {
        ...super._template().Subtitle,
        visible: false,
      },
    }
  }

  get manageSubscriptionButton() {
    return this.tag('ManageSubscriptionButton')
  }

  static getTitleText() {
    return getText('paywallTitle')
  }

  static getSubtitleText() {
    return ''
  }

  _active() {
    this._currentButton = this.manageSubscriptionButton
    this._refocus()
  }

  _handleEnter() {
    if (this._currentButton === this.manageSubscriptionButton) {
      Router.navigate(SUBSCRIPTION, this._contextData)
    }
  }

  _handleBack() {
    const history = Router.getHistory()

    if (history.length > 0) {
      Router.back()
    } else {
      Router.navigate(BASE_ROUTES.HOME)
    }
  }
}
